import React, { useEffect, useRef, useState } from 'react';

export default function VisionMission({ content }) {
  const { title, vision, vision_description, mission, mission_description, items } = content || {};
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, { threshold: 0.15 });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-bg-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{title || 'Visi & Misi'}</h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" />
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          <div className={`bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 ${visible ? 'animate-fadeInUp' : 'opacity-0'}`} style={{ borderTop: '4px solid #66E0FF' }}>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'rgba(0,207,255,0.1)' }}>
                <svg className="w-6 h-6" style={{ color: '#66E0FF' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">{vision || 'Visi Kami'}</h3>
            </div>
            <p className="text-gray-600 leading-relaxed">{vision_description || 'Menjadi perusahaan pembersih ramah lingkungan terdepan di Indonesia yang menginspirasi gaya hidup berkelanjutan.'}</p>
          </div>

          <div className={`bg-white rounded-2xl p-8 shadow-sm border-t-4 border-accent hover:shadow-lg transition-all duration-300 ${visible ? 'animate-fadeInUp' : 'opacity-0'}`} style={{ animationDelay: '0.15s' }}>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center">
                <svg className="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900">{mission || 'Misi Kami'}</h3>
            </div>
            <p className="text-gray-600 leading-relaxed mb-4">{mission_description || 'Menghadirkan produk pembersih inovatif berbasis eco-enzyme yang aman bagi keluarga dan lingkungan.'}</p>
            {(items || []).length > 0 && (
              <ul className="space-y-2">
                {items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                    <svg className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}